import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

import { Box, Card, CircularProgress, Grid, TextField } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';
import moment from 'moment/moment';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const NewUser = ({ setOpen, getUsers, toEditRow, setToEditRow, setSnackbarMsgType, setOpenSnackBar }) => {
    const [editMode, setEditMode] = useState(false)

    const handleClose = () => {
        setOpen(false);
        setToEditRow(null)
    };

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");


    useEffect(() => {
        if (toEditRow != null) {
            setEditMode(true)
            setName(toEditRow.name)
            setSurname(toEditRow.surname)
            setUsername(toEditRow.username)
            setEmail(toEditRow.email)

        }

    }, [toEditRow])

    const [passLengthErr, setPassLengthErr] = useState(false)
    const [passMatchErr, setPassMatchErr] = useState(false)
    const [emailErr, setEmailErr] = useState(false)
    useEffect(() => {
        if (password != "" && password.length < 8) {
            setPassLengthErr(true)
        } else {
            setPassLengthErr(false)
        }

        if (confirmPassword != "" && confirmPassword != password) {
            setPassMatchErr(true)
        } else {
            setPassMatchErr(false)
        }

    }, [password, confirmPassword])

    function ValidateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        return (false)
    }

    useEffect(() => {
        if (email != "" && !ValidateEmail(email)) {
            setEmailErr(true)
        } else {
            setEmailErr(false)
        }

    }, [email])

    const [loading, setLoading] = useState(false)
    const handleNewUser = async (e) => {
        e.preventDefault();
        if (email.length === 0 || !editMode && password.length === 0 || !editMode && confirmPassword.length === 0 || emailErr || passMatchErr || passLengthErr || username.length === 0 || name.length === 0 || surname.length === 0) {
            return
        }
        setLoading(true)
        try {
            await axiosInstance.post("/user", {
                "name": name,
                "surname": surname,
                "username": username,
                "email": email,
                "password": password,
                "createDate": moment(new Date).format('YYYY-MM-DDTHH:mm:ss[Z]'),
            })
            getUsers()
            setOpen(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "User Added Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: err.response.data,
                type: "error"
            })
        } finally {
            setLoading(false)
        }
    }
    const handleUpdateUser = async (e) => {
        e.preventDefault();
        if (emailErr || username.length === 0 || name.length === 0 || surname.length === 0) {
            return
        }
        setLoading(true)
        try {
            await axiosInstance.put("/user", {
                "userId": toEditRow.userid,
                "name": name,
                "surname": surname,
                "username": username,
                "email": email,
                "password": password
            })
            setToEditRow(null)
            getUsers()
            setOpen(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "User Updated Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: err.response.data,
                type: "error"
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={true}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                        <Button autoFocus variant='contained' color="error" onClick={handleClose}>
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>
                <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} sx={{ height: "100%" }} >
                    <Card sx={{ maxWidth: "600px", p: 3, width: "100%" }}>
                        <Box textAlign={"center"} sx={{ my: 4 }}>
                            <Typography sx={{ fontSize: "24px", fontWeight: 700 }}>{editMode ? "UPDATE" : "CREATE"} USER</Typography>
                            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Te gjitha fushat jane te detyruara!</Typography>
                        </Box>
                        <Grid container spacing={2} >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>First name</Typography>
                                    <TextField name='user-name' inputProps={{
                                        autocomplete: 'new-password',
                                        form: {
                                            autocomplete: 'off',
                                        },
                                    }} value={name} size='small' sx={{ width: "100%" }} onChange={e => setName(e.target.value)} />
                                </Box>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Last name</Typography>
                                    <TextField name='user-lastname' inputProps={{
                                        autocomplete: 'new-password',
                                        form: {
                                            autocomplete: 'off',
                                        },
                                    }} value={surname} size='small' sx={{ width: "100%" }} onChange={e => setSurname(e.target.value)} />
                                </Box>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Username</Typography>
                                    <TextField name='user-username' inputProps={{
                                        autocomplete: 'new-password',
                                        form: {
                                            autocomplete: 'off',
                                        },
                                    }} value={username} size='small' sx={{ width: "100%" }} onChange={e => setUsername(e.target.value)} />
                                </Box>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Email</Typography>
                                    <TextField name="user-email" inputProps={{
                                        autocomplete: 'new-password',
                                        form: {
                                            autocomplete: 'off',
                                        },
                                    }} value={email} size='small' sx={{ width: "100%" }} onChange={e => setEmail(e.target.value)} />
                                    {
                                        emailErr ? <span style={{ color: "red" }}>Email jo i vlefshem!</span> : ""
                                    }
                                </Box>
                            </Grid>
                            {
                                editMode ?
                                    <>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box>
                                                <Typography>Password</Typography>
                                                <TextField name="user-password1" inputProps={{
                                                    autocomplete: 'new-password',
                                                    form: {
                                                        autocomplete: 'off',
                                                    },
                                                }} type='password' value={password} size='small' sx={{ width: "100%" }} onChange={e => setPassword(e.target.value)} />
                                                {
                                                    passLengthErr ? <span style={{ color: "red" }}>Passwordi duhet te pakten 8 karaktere i gjate!</span> : ""
                                                }
                                            </Box>
                                        </Grid>
                                    </> :
                                    <>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box>
                                                <Typography>Password</Typography>
                                                <TextField name="user-password1" inputProps={{
                                                    autocomplete: 'new-password',
                                                    form: {
                                                        autocomplete: 'off',
                                                    },
                                                }} type='password' value={password} size='small' sx={{ width: "100%" }} onChange={e => setPassword(e.target.value)} />
                                                {
                                                    passLengthErr ? <span style={{ color: "red" }}>Passwordi duhet te pakten 8 karaktere i gjate!</span> : ""
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box>
                                                <Typography>Confirm Password</Typography>
                                                <TextField name="confirm-user-password" inputProps={{
                                                    autocomplete: 'new-password',
                                                    form: {
                                                        autocomplete: 'off',
                                                    },
                                                }} type='password' value={confirmPassword} size='small' sx={{ width: "100%" }} onChange={e => setConfirmPassword(e.target.value)} />
                                                {
                                                    passMatchErr ? <span style={{ color: "red" }}>Passwordet nuk perputhen!</span> : ""
                                                }
                                            </Box>
                                        </Grid>
                                    </>
                            }

                            <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"center"}>
                                <Button disabled={loading || email.length === 0 || !editMode && password.length === 0 || !editMode && confirmPassword.length === 0 || emailErr || passMatchErr || passLengthErr || username.length === 0 || name.length === 0 || surname.length === 0} onClick={editMode ? handleUpdateUser : handleNewUser} color='primary' variant='contained'>
                                    {
                                        loading ? <CircularProgress /> : "RUAJ"
                                    }
                                </Button>
                            </Grid>
                        </Grid>
                    </Card>
                </Box>

            </Dialog>

        </div>
    )
}

export default React.memo(NewUser, (p, n) => p.toEditRow === n.toEditRow)